import React from 'react'

export default <div>this is an invite</div>
